import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["layoutType", "open", "onOpenChange", "items", "selection", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Droplist } from '@snack-uikit/list';
import { extractSupportProps } from '@snack-uikit/utils';
import { MobileDroplist } from '../MobileDroplist';
import { jsx as _jsx } from "react/jsx-runtime";
export function AdaptiveDroplist(_ref) {
  var layoutType = _ref.layoutType,
    open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    items = _ref.items,
    selection = _ref.selection,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isMobile = layoutType === 'mobile';
  return isMobile ? /*#__PURE__*/_jsx(MobileDroplist, _objectSpread(_objectSpread({
    open: open,
    onOpenChange: onOpenChange,
    items: items,
    selection: selection
  }, extractSupportProps(rest)), {}, {
    children: children
  })) : /*#__PURE__*/_jsx(Droplist, _objectSpread(_objectSpread({
    open: open,
    onOpenChange: onOpenChange,
    items: items,
    selection: selection
  }, rest), {}, {
    children: children
  }));
}